// Angular Imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Third party imports
import { DxFormComponent } from 'devextreme-angular';

// Constant imports
import { Constants } from '../../../../../_constants/constants';
import { StringFormatConstants } from '../../../../../_constants/string-format-constants';

// Service imports
import { PrecisionService } from '../../../../../_services/shared-services/precision.service';
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { InvoiceDetailsService } from '../../../_services/account-receivable/invoice-details.service';

// Model imports
import { ARInvoiceWriteOffParameterDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-write-off-parameter-dto';
import { ARInvoiceDetailParameterDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';

@Component({
    selector: 'app-write-off-invoice-confirmation',
    templateUrl: './write-off-invoice-confirmation.component.html',
    styleUrls: ['./write-off-invoice-confirmation.component.scss']
})
export class WriteOffInvoiceConfirmationComponent implements OnInit {
    @ViewChild('confirmForm', { static: false }) confirmForm: DxFormComponent;
    @Input() visible = false;
    @Input() invoiceDetails: any;
    @Input() invoiceId: number;
    @Input() invoiceDetailParam: ARInvoiceDetailParameterDto;

    @Output() onWriteOffInvoiceClose = new EventEmitter<boolean>();

    defaultLabelLocation: string = Constants.defaultFormLabelLocation;
    loadingVisible = false;
    closeIcon: string = IconConstants.CLOSE;
    saveIcon: string = IconConstants.CHECK_MARK;
    minAmount = 1;
    currencyFormat: any;
    writeOffAmount: number;

    invoiceWriteOffDetail: ARInvoiceWriteOffParameterDto = new ARInvoiceWriteOffParameterDto();

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService,
        private readonly invoiceDetailsService: InvoiceDetailsService
    ) {
        this.currencyFormat = this.precisionService.updatePrecisionPoint(StringFormatConstants.currencyFormat);
    }

    ngOnInit() {
        if (!!this.invoiceDetails) {
            this.writeOffAmount = this.invoiceDetails.chargeDue;
            this.invoiceWriteOffDetail.writeOffDescription = `Write-Off of ${this.invoiceDetails.documentNumber}`;
        }
    }

    onWriteOffClick(): void {
        if (!!this.confirmForm && this.confirmForm.instance) {
            const validator = this.confirmForm.instance.validate().isValid;
            if (validator) {
                this.invoiceWriteOffDetail.invoiceId = this.invoiceId;
                this.invoiceWriteOffDetail.communityId = this.invoiceDetailParam.communityId;
                this.invoiceWriteOffDetail.managementCompanyId = this.invoiceDetailParam.managementCompanyId;
                this.invoiceWriteOffDetail.clearCache = true;
                this.loadingVisible = true;
                this.invoiceDetailsService.writeOffARInvoice(this.invoiceWriteOffDetail).subscribe(
                    () => {
                        this.visible = false;
                        this.onWriteOffInvoiceClose.emit(true);
                        this.loadingVisible = false;
                    },
                    (error) => {
                        this.loadingVisible = false;
                        this.errorService.displayError(error);
                        this.onHidden(null);
                    }
                );
            }
        }
    }

    onHidden(e): void {
        this.visible = false;
        this.onWriteOffInvoiceClose.emit(false);
    }
}
